import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The website gates, spread into FEATURE_GATE_SEEDS in feature-gate-registry.ts at their place in the
 * admin page order. Native websites (docs/plans/2026-11-05-feat-native-websites-gate-plan.md) is
 * created trialing by the native_websites_gate migration.
 */
export const WEBSITE_FEATURE_GATE_SEEDS = {
  websites: {
    label: 'Websites',
    shortLabel: 'Websites',
    description: 'Office campaign websites and CRM form submissions.',
    group: 'campaigns_creative',
    navItemIds: ['websites', 'website-analytics'],
  },
  newsroom: {
    label: 'Newsroom',
    shortLabel: 'Newsroom',
    description:
      "Media releases and articles managed in Pulse, approved under the office's policy and served live on its website.",
    group: 'campaigns_creative',
  },
  native_websites: {
    label: 'Native websites',
    shortLabel: 'Native websites',
    description:
      'Full Next.js websites, zip source import and Pulse AI website builds. Not a sidebar item; off means the office creates classic campaign pages only.',
    group: 'campaigns_creative',
  },
} satisfies Record<string, FeatureGateSeed>;
